






import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Spark Commodities',
    },
  },
})
export default class SparkLogo extends Vue {
  public showTitle!: boolean;
  public title!: string;
}
